import React, {Component} from 'react';
import Api from '../Api';
import {
    Switch,
    Route
  } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import { LinkContainer } from "react-router-bootstrap";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import DetallMunicipi from './municipi/DetallMunicipi';
import LlistaMunicipis from './municipi/LlistaMunicipis';

class Municipi extends Component {

    
render() {   


  return (
    <div className="municipi">
        
        
        <Container>
            <Switch>
                <Route path={[`${this.props.match.path}/:municipiSlug/:opcions?`]} render={(params) => (<DetallMunicipi {...params} municipis={this.props.municipis} resultats={this.props.resultats} partits={this.props.partits}/>)}/>
                <Route path={this.props.match.path}>
                    <LlistaMunicipis municipis={this.props.municipis} resultats={this.props.resultats} partits={this.props.partits}/>
                </Route>
            </Switch>
            <Breadcrumb>
                <LinkContainer to="/resultats/"><Breadcrumb.Item>Resultats poble a poble</Breadcrumb.Item></LinkContainer>
                <LinkContainer to="/bergueda/"><Breadcrumb.Item>Resultats totals del Berguedà</Breadcrumb.Item></LinkContainer>
            </Breadcrumb>
      </Container>
    </div>
  );
}

}

export default Municipi; 